import { render, staticRenderFns } from "./tabThree.vue?vue&type=template&id=965300b4"
import script from "./tabThree.vue?vue&type=script&lang=js"
export * from "./tabThree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports